// ABOUTME: Renders python-viz with accompanying summary bullets (70/30 split).
// ABOUTME: Stacks vertically on narrow screens, side-by-side on large screens.

import React from 'react';
import { PythonVizRenderer } from './PythonVizRenderer';
import type { PythonVizConfig, SummaryConfig } from '../../types/sdk';

interface PythonVizWithSummaryRendererProps {
  pythonViz: PythonVizConfig;
  summary: SummaryConfig;
  className?: string;
}

const emphasisStyles = {
  normal: 'text-surface-600',
  highlight: 'text-surface-800 font-medium',
  critical: 'text-error font-medium',
};

export const PythonVizWithSummaryRenderer: React.FC<PythonVizWithSummaryRendererProps> = ({
  pythonViz,
  summary,
  className = '',
}) => {
  return (
    <div className={`flex flex-col lg:flex-row gap-4 ${className}`}>
      {/* 70% - Visualization */}
      <div className="lg:w-[70%]">
        <PythonVizRenderer pythonViz={pythonViz} />
      </div>

      {/* 30% - Summary bullets */}
      <div className="lg:w-[30%] card rounded-sm p-4">
        <h4 className="text-sm font-medium text-surface-600 mb-3">
          Key Takeaways
        </h4>
        <ul className="space-y-2">
          {summary.bullet_points?.map((bullet, index) => (
            <li
              key={index}
              className={`flex items-start gap-2 text-sm ${
                emphasisStyles[bullet.emphasis || 'normal']
              }`}
            >
              <span className="text-primary-600 mt-1">•</span>
              <span>{bullet.text}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default PythonVizWithSummaryRenderer;
